/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ssc_App_NameInputs */

const en_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const es_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const fr_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const de_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ja_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const zh_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ar_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const id_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const it_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ru_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const pt_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ko_ssc_app_name = /** @type {(inputs: Ssc_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "Shoot Share Connect" |
*
* @param {Ssc_App_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ssc_app_name = /** @type {((inputs?: Ssc_App_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ssc_App_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ssc_app_name(inputs)
	if (locale === "es") return es_ssc_app_name(inputs)
	if (locale === "fr") return fr_ssc_app_name(inputs)
	if (locale === "de") return de_ssc_app_name(inputs)
	if (locale === "ja") return ja_ssc_app_name(inputs)
	if (locale === "zh") return zh_ssc_app_name(inputs)
	if (locale === "ar") return ar_ssc_app_name(inputs)
	if (locale === "id") return id_ssc_app_name(inputs)
	if (locale === "it") return it_ssc_app_name(inputs)
	if (locale === "ru") return ru_ssc_app_name(inputs)
	if (locale === "pt") return pt_ssc_app_name(inputs)
	return ko_ssc_app_name(inputs)
});